import { useRef } from "react";
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from "intl-tel-input/react/build/IntlTelInput.esm";
import "../../node_modules/intl-tel-input/build/js/utils";
import { useProductData } from "@/zustand/productStore";

const PhoneField = ({ handleChange, error, value }) => {
  const searchLabel = window.post_template?.checkout_v4_form.checkout_v4_formLabels?.tr_checkout_v4_form_searchLabel;
  const itiRef = useRef(null);
  const { country_code } = useProductData();
  const isEnhancedContrast = window.enhancedContrast;

  if (country_code) {
    return (
      <div className="input-container" style={{ width: "100%", height: "100%" }}>
        <div
          className={`input ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast" && "enhancedContrast"} ${isEnhancedContrast && "enhancedContrast" && error && "enhancedContrast__error"}`}
          style={{ padding: "0px" }}
        >
          <IntlTelInput
            id="phone"
            initialValue={value}
            onChangeNumber={(value) => {
              handleChange(value);
            }}
            autoComplete={"tel"}
            initOptions={{
              initialCountry: country_code,
              showSelectedDialCode: true,
              autoPlaceholder: "aggressive",
              nationalMode: false,
              countrySearch: true,
              i18n: {
                searchPlaceholder: searchLabel,
              },
              containerClass: isEnhancedContrast && "enhancedContrast" ? "iti_enhancedContrast" : "",
            }}
          />
        </div>
        {error && <div className="formError">{error}</div>}
      </div>
    );
  }
};

export default PhoneField;
